// @flow

// Types
import type {
  Comment,
} from 'hfty-model-comments/types'

// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'

// Utils
import traverse from 'fc-utils/traverse'
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Constants
import { TREE, BRANCH } from '../constants'

export default createSelector(
  [traverse([TREE, BRANCH])],
  function (comments: { [number]: Comment }): Array<Comment> {
    return emptyArrayOr(_map(comments))
  }
)
